import { HttpClient } from "@angular/common/http";
import { Component } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import swal from "sweetalert2";
import { mdlClaimStatusReq } from "../../Models/Claims";
import { mdlClaimStatus, mdlGetClaimStatusRes } from "../../Models/mdlGetClaimStatusRes ";
import { mdlPayloadRequest } from "../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../Models/mdlPayloadResponse";
import { restURL } from "../../Models/restURL";
import { LanguageService } from "../../Services/languageService";
import { motorProposalService } from "../../Services/motorProposalService";
import { userService } from "../../Services/userService";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: "ClaimStatus",
    templateUrl: "./ClaimStatus.html",
    styleUrls: ["./ClaimStatus.css"],
})

export class ClaimStatus {
    public objSearchReq: mdlClaimStatusReq = new mdlClaimStatusReq();
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();
    public ClaimStatusRes: mdlGetClaimStatusRes = new mdlGetClaimStatusRes();
    public CurrentClaimStatus: Array<mdlClaimStatus> = new Array<mdlClaimStatus>()
    public ShowClaimStatus: boolean = false;
    public isShowLoading: boolean;
    public Lang: any;
    public LngSubscription: Subscription;
    constructor(private translate: TranslateService, private userInfo: userService, private http: HttpClient, private lngService: LanguageService, public url: restURL, private EncriptService: motorProposalService,) {
        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lang = lng });
        if (this.Lang == undefined) { this.Lang = "en" }
    }

    GetCalimStatus() {
        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objSearchReq));
        this.isShowLoading = true;
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "Claims/GetClaimStatus", this.objPayloadRequest, this.userInfo.getHttpOptions()).toPromise().then((result) => {
            this.isShowLoading = false;
            this.objPayloadResponse = result;
            this.ClaimStatusRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
            if (this.ClaimStatusRes.st.StatusCode != "S") {
                swal(this.translate.instant(this.ClaimStatusRes.st.StatusDesc))
                return;
            }

            this.ShowClaimStatus = true;
            this.CurrentClaimStatus = new Array<mdlClaimStatus>()
            if (this.ClaimStatusRes.ClaimNoList != null && this.ClaimStatusRes.ClaimNoList.length == 1) {
                this.ShowClaimsStatus(this.ClaimStatusRes.ClaimNoList[0]);
            }


        }, (error) => {
            this.userInfo.checkTokenStatus(error);
            this.isShowLoading = false;
        });
    }

    HideClaimStatus() {
        this.ShowClaimStatus = false;
    }

    ShowClaimsStatus(val) {
        this.CurrentClaimStatus = new Array<mdlClaimStatus>()
        this.CurrentClaimStatus = this.ClaimStatusRes.ClaimStatusList.filter(a => a.ClaimNumber == val.ClaimNumber);
    }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/ClaimStatus/ClaimStatus.ts